import { useQuery } from '@tanstack/react-query';
import {
  getOverviewMetrics,
  getRevenueTrend,
  OverviewMetrics,
  RevenueTrendPoint,
} from '@/api/stripeService';
import { queryKeys } from '@/lib/queryKeys';

export const useAdminDashboard = () => {
  const overview = useQuery<OverviewMetrics>({
    queryKey: queryKeys.stripeOverview,
    queryFn: getOverviewMetrics,
    refetchInterval: 5 * 60 * 1000,
  });

  const revenueTrend = useQuery<RevenueTrendPoint[]>({
    queryKey: queryKeys.stripeRevenueTrend('month'),
    queryFn: () => getRevenueTrend('month'),
    refetchInterval: 5 * 60 * 1000,
  });

  return {
    overview: overview.data,
    overviewLoading: overview.isLoading,
    overviewError: overview.isError,
    revenueTrend: revenueTrend.data ?? [],
    revenueTrendLoading: revenueTrend.isLoading,
    revenueTrendError: revenueTrend.isError,
  };
};
